var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon38(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(-599 -4387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(599 4387)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_skyscrapers",
    d: "M10.429,3V6.616L3,11.074v15.7a2.994,2.994,0,0,0,2.972,2.972h20.8a2.994,2.994,0,0,0,2.972-2.972V10.429H26.774V8.944H22.317V3ZM13.4,5.972h5.944v20.8H13.4Zm-2.972,4.109V26.774H5.972V12.757Zm11.887,1.834H23.8V13.4h2.972V26.774H22.317Z",
    transform: "translate(613 4401)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon38);
export default __webpack_public_path__ + "static/media/facilityIcon38.cad9f64bf9e968f6f98c4dea510c4d19.svg";
export { ForwardRef as ReactComponent };